module.exports = __webpack_public_path__ + "static/media/Moving Hours icon.bfd9d059.svg";